import React, { useEffect, useState, useRef } from 'react';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import axios from 'axios';

const CompanyBusinessDetails = (props) => {
  const { state } = useLocation();

  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  const [disable, setDisable] = useState(true);

  console.log('Disable', disable);

  const [checkboxMsg, setCheckboxMsg] = useState(true);

  const [alertMessage, setAlertMessage] = useState('');

  const fieldRefs = useRef({});

  const [data, setData] = useState({
    id: state ? state.id : '',
    bisiness_name: '',
    trade_lic_no: '',
    gst_no: '',
    pan_no: '',
    state: '',
    district: '',
    city: '',
    pin: '',
    street: '',
    land_mark: '',
    mobile: state ? state.user.mobile : '',
    alt_mobile: '',
    address: '',
    business_category: '',
    name_of_ac_owner: '',
    ac_no: '',
    bank_name: '',
    ifsc_code: '',
    bank_branch: '',
    business_email: '',
    business_description: ''
  });

  const [fetchStates, setFetchStates] = useState();

  const [fetchCities, setFetchCities] = useState();

  const [fetchDistricts, setFetchDistricts] = useState();

  const [fetchBusinessCat, setFetchBusinessCat] = useState();

  const [selectedStateId, setSelectedStateId] = useState();

  const validateForm = () => {
    const validationErrors = {};

    const mobileRegex = /^[6-9]\d{9}$/;

    if (!data.bisiness_name || data.bisiness_name.trim() === '') {
      validationErrors.bisiness_name = 'Business name is required.';
    }
    if (!data.trade_lic_no || data.trade_lic_no.trim() === '') {
      validationErrors.trade_lic_no = 'Trade licence number is required.';
    }

    if (!data.pan_no || data.pan_no.trim() === '') {
      validationErrors.pan_no = 'PAN number is required.';
    }
    if (!data.state) {
      validationErrors.state = 'State is required.';
    }
    if (!data.district) {
      validationErrors.district = 'District is required.';
    }
    if (!data.city) {
      validationErrors.city = 'City is required.';
    }
    if (!data.pin || data.pin.trim() === '') {
      validationErrors.pin = 'PIN is required.';
    }
    if (!data.street || data.street.trim() === '') {
      validationErrors.street = 'Street is required.';
    }
    if (!data.land_mark || data.land_mark.trim() === '') {
      validationErrors.land_mark = 'Landmark is required.';
    }
    if (!data.address || data.address.trim() === '') {
      validationErrors.address = 'Address is required.';
    }
    if (!data.mobile || data.mobile.toString().trim() === '') {
      validationErrors.mobile = 'Mobile number is required.';
    } else if (!mobileRegex.test(data.mobile.toString().trim())) {
      validationErrors.mobile = 'Enter a valid 10 digit mobile number.';
    }

    if (!data.business_category) {
      validationErrors.business_category = 'Business type is required.';
    }
    if (!data.business_email || data.business_email.trim() === '') {
      validationErrors.business_email = 'Business email is required.';
    }
    if (!data.business_description || data.business_description.trim() === '') {
      validationErrors.business_description = 'Business description is required.';
    }
    if (!data.name_of_ac_owner || data.name_of_ac_owner.trim() === '') {
      validationErrors.name_of_ac_owner = 'Account owner name is required.';
    }
    if (!data.ac_no || data.ac_no.trim() === '') {
      validationErrors.ac_no = 'Account number is required.';
    }
    if (!data.ifsc_code || data.ifsc_code.trim() === '') {
      validationErrors.ifsc_code = 'IFSC code is required.';
    }
    if (!data.bank_name || data.bank_name.trim() === '') {
      validationErrors.bank_name = 'Bank name is required.';
    }
    if (!data.bank_branch || data.bank_branch.trim() === '') {
      validationErrors.bank_branch = 'Branch is required.';
    }

    setErrors(validationErrors);

    return Object.keys(validationErrors).length === 0;
  };

  const scrollToFirstError = (errorFields) => {
    const fieldNames = Object.keys(errorFields);
    if (fieldNames.length > 0) {
      const firstErrorField = fieldNames[0];
      const fieldRef = fieldRefs.current[firstErrorField];

      if (fieldRef) {
        fieldRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  const showErrorAlert = (errorFields) => {
    const fieldNames = Object.keys(errorFields);
    if (fieldNames.length > 0) {
      const firstError = errorFields[fieldNames[0]];
      setAlertMessage(firstError);

      setTimeout(() => {
        setAlertMessage('');
      }, 5000);
    }
  };

  const handleCheckbox = () => {
    if (disable === true) {
      setDisable(false);
      setCheckboxMsg(false);
    } else {
      setDisable(true);
      setCheckboxMsg(true);
    }
  };

  const handleSubmit = async () => {
    const isValid = validateForm();
    if (!isValid) {
      scrollToFirstError(errors);
      showErrorAlert(errors);
      return;
    }

    try {
      const response = await axios.post(`seller/registration/business`, data);
      console.log('data', response.data);
      if (response.data.success) {
        navigate('/registration/documentUpload', {
          state: { id: response.data.data.id, user: response.data.data }
        });
      }
    } catch (error) {
      if (error.response && error.response.status == 400) {
        const backendErrors = error.response.data.errors || {};
        setErrors(backendErrors);

        // Extract error message from backend response
        if (error.response.data.message) {
          setAlertMessage(error.response.data.message);
        } else {
          // If no specific message, show first field error
          showErrorAlert(backendErrors);
        }

        scrollToFirstError(backendErrors);

        // Auto-clear alert after 5 seconds
        setTimeout(() => {
          setAlertMessage('');
        }, 5000);
      } else {
        // Generic error handling for other status codes
        const errorMsg = error.response?.data?.message || 'An error occurred. Please try again.';
        setAlertMessage(errorMsg);

        setTimeout(() => {
          setAlertMessage('');
        }, 5000);
      }
    }
  };

  const fetchState = async () => {
    try {
      const response = await axios.get(`/seller/masters/state/list`);

      if (response.data.success) {
        setFetchStates(response.data.data);
      } else {
      }
    } catch (error) {}
  };

  const fetchDistrict = async (state_id) => {
    // console.log ('stateid', state_id);
    const data = {
      state_id: state_id
    };
    setSelectedStateId(state_id);
    try {
      const response = await axios.post(`/seller/district/dropdown/list`, data);
      // console.log("district data",response.data);
      setFetchDistricts(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCity = async (district) => {
    // console.log ('district id', district );
    // const data ={
    //   stateId : selectedStateId && ,
    //   district : district
    // }
    try {
      const response = await axios.get(`/seller/masters/city/list/${selectedStateId}/${district}`);
      console.log('city', response.data);
      if (response.data.success) {
        setFetchCities(response.data.data);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const handleDistrict = (district) => {
    // console.log(district  , 'fetch districts id');
    setData({
      ...data,
      // state : state,
      district: district
    });
    fetchCity(district);
  };

  const handleState = (state) => {
    setData({
      ...data,
      state: state
    });
    fetchDistrict(state);
    // console.log(state , 'handle state fetch districts');
    // fetchCity(state);
  };
  const fetchBusinessCategory = async () => {
    try {
      const response = await axios.get(`seller/masters/business/category`);
      // console.log("city" , response.data);
      if (response.data.success) {
        setFetchBusinessCat(response.data.data);
      } else {
      }
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // window.scrollTo(0, 0);
    fetchState();
    fetchBusinessCategory();
  }, []);
  return (
    <div className="responsive-xs responsive-sm">
      {/* Alert Message */}
      {alertMessage && (
        <div
          style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '12px 20px',
            marginBottom: '20px',
            borderRadius: '4px',
            border: '1px solid #f5c6cb',
            position: 'sticky',
            top: '0',
            zIndex: '1000',
            fontSize: '14px'
          }}>
          <strong>Error:</strong> {alertMessage}
        </div>
      )}
      {/* Header */}
      <div className="companyBusinessDetailsPageHeader">
        <div style={{ width: '15%' }}>
          <img src="/logo.webp" className="site-logo" />
        </div>
        <div>
          <Link to="/registration" style={{ textDecorationLine: 'none' }}>
            <div className="login">Create New Account</div>
          </Link>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="a-section legal-page-fragment ng-scope">
            <div className="a-box seller_message_box">
              <div className="a-box-inner">
                <h1>Register and Start Selling</h1>
                <p className="seller_message_p"></p>
                <p className="seller_message_p">
                  Please have the following ready before you begin:
                </p>
                <ul className="mt-3">
                  <li className="seller_message_p">
                    Your bank account details for receiving payments from Aivimart
                  </li>
                  <li className="seller_message_p">
                    Tax (Trade Licence/PAN) details of your business
                  </li>
                </ul>
                <p className="seller_message_p">
                  Please ensure that all the information you submit is accurate.
                </p>
                <p></p>
                <h5 style={{ fontWeight: 'bold' }}>Enter details below to continue registration</h5>
              </div>
            </div>
          </div>
          <form>
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <label className="form-label label-txt">Company/Business name *</label>
                  <input
                    ref={(el) => (fieldRefs.current.bisiness_name = el)}
                    type="text"
                    className="form-control "
                    onChange={(e) => setData({ ...data, bisiness_name: e.target.value })}
                  />
                  {errors && errors.bisiness_name && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.bisiness_name}</p>
                  )}
                </div>

                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Trade Licence Number *</label>
                  <input
                    ref={(el) => (fieldRefs.current.trade_lic_no = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, trade_lic_no: e.target.value })}
                  />
                  {errors && errors.trade_lic_no && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.trade_lic_no}</p>
                  )}
                </div>

                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">GST Number </label>
                  <input
                    ref={(el) => (fieldRefs.current.gst_no = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, gst_no: e.target.value })}
                  />
                  {errors && errors.gst_no && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.gst_no}</p>
                  )}
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-md-3 ">
                  <label className="form-label label-txt col-md-7">Pan No *</label>
                  <input
                    ref={(el) => (fieldRefs.current.pan_no = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, pan_no: e.target.value })}
                  />
                  {errors && errors.pan_no && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.pan_no}</p>
                  )}
                </div>
                <div className="col-md-3 ">
                  <label className="form-label label-txt col-md-7">State *</label>
                  <select
                    ref={(el) => (fieldRefs.current.state = el)}
                    class="form-select"
                    aria-label="Default select example"
                    onChange={(state) => handleState(state.target.value)}>
                    <option selected value="">
                      {' '}
                      Select states
                    </option>
                    {fetchStates &&
                      fetchStates.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {' '}
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {errors && errors.state && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.state}</p>
                  )}
                </div>

                <div className="col-md-3 ">
                  <label className="form-label label-txt col-md-7">District *</label>
                  <select
                    ref={(el) => (fieldRefs.current.district = el)}
                    class="form-select"
                    aria-label="Default select example"
                    onChange={(district) => handleDistrict(district.target.value)}>
                    <option selected value="">
                      {' '}
                      Select District
                    </option>
                    {fetchDistricts &&
                      fetchDistricts.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {' '}
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {errors && errors.district && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.district}</p>
                  )}
                </div>
                <div className="col-md-3 ">
                  <label className="form-label label-txt col-md-7">City *</label>
                  <select
                    ref={(el) => (fieldRefs.current.city = el)}
                    class="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setData({ ...data, city: e.target.value })}>
                    <option selected value="">
                      {' '}
                      Select City
                    </option>
                    {fetchCities &&
                      fetchCities.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {' '}
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {errors && errors.city && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.city}</p>
                  )}
                </div>
                {/* </div> */}
                {/* <div className="row mt-2"> */}
                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Pin *</label>
                  <input
                    ref={(el) => (fieldRefs.current.pin = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, pin: e.target.value })}
                  />
                  {errors && errors.pin && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.pin}</p>
                  )}
                </div>

                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Street *</label>
                  <input
                    ref={(el) => (fieldRefs.current.street = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, street: e.target.value })}
                  />
                  {errors && errors.street && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.street}</p>
                  )}
                </div>

                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Landmark *</label>
                  <input
                    ref={(el) => (fieldRefs.current.land_mark = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, land_mark: e.target.value })}
                  />
                  {errors && errors.land_mark && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.land_mark}</p>
                  )}
                </div>
                <div className="row mt-2">
                  <div className="col-md-12 ">
                    <label className="form-label label-txt col-md-7">Address *</label>
                    <textarea
                      ref={(el) => (fieldRefs.current.address = el)}
                      className="form-control"
                      aria-label="With textarea"
                      onChange={(e) => setData({ ...data, address: e.target.value })}></textarea>
                    {errors && errors.address && (
                      <p style={{ color: 'red', fontSize: 12 }}>{errors.address}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Alt Mobile </label>
                  <input
                    ref={(el) => (fieldRefs.current.alt_mobile = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, alt_mobile: e.target.value })}
                  />
                  {errors && errors.alt_mobile && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.alt_mobile}</p>
                  )}
                </div>
                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Bussiness Type *</label>
                  <select
                    ref={(el) => (fieldRefs.current.business_category = el)}
                    class="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setData({ ...data, business_category: e.target.value })}>
                    <option selected value="">
                      {' '}
                      Select Bussiness Type
                    </option>
                    {fetchBusinessCat &&
                      fetchBusinessCat.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {' '}
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {errors && errors.business_category && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.business_category}</p>
                  )}
                </div>
                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Bussiness Email *</label>
                  <input
                    ref={(el) => (fieldRefs.current.business_email = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, business_email: e.target.value })}
                  />
                  {errors && errors.business_email && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.business_email}</p>
                  )}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <label className="form-label label-txt col-md-7">Bussiness Description *</label>
                  <input
                    ref={(el) => (fieldRefs.current.business_description = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, business_description: e.target.value })}
                  />
                  {errors && errors.business_description && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.business_description}</p>
                  )}
                </div>
              </div>

              <div className="row mt-5 ">
                <h5 style={{ fontWeight: 'bold' }} className="mb-4">
                  Bank Details
                </h5>
                <div className="col-md-4 ">
                  <label className="form-label label-txt">Name of account Owner *</label>
                  <input
                    ref={(el) => (fieldRefs.current.name_of_ac_owner = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, name_of_ac_owner: e.target.value })}
                  />
                  {errors && errors.name_of_ac_owner && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.name_of_ac_owner}</p>
                  )}
                </div>

                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Account Number *</label>
                  <input
                    ref={(el) => (fieldRefs.current.ac_no = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, ac_no: e.target.value })}
                  />
                  {errors && errors.ac_no && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.ac_no}</p>
                  )}
                </div>

                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">IFSC Code *</label>
                  <input
                    ref={(el) => (fieldRefs.current.ifsc_code = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, ifsc_code: e.target.value })}
                  />
                  {errors && errors.ifsc_code && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.ifsc_code}</p>
                  )}
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Bank Name *</label>
                  <input
                    ref={(el) => (fieldRefs.current.bank_name = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, bank_name: e.target.value })}
                  />
                  {errors && errors.bank_name && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.bank_name}</p>
                  )}
                </div>
                <div className="col-md-4 ">
                  <label className="form-label label-txt col-md-7">Branch *</label>
                  <input
                    ref={(el) => (fieldRefs.current.bank_branch = el)}
                    type="text"
                    className="form-control"
                    onChange={(e) => setData({ ...data, bank_branch: e.target.value })}
                  />
                  {errors && errors.bank_branch && (
                    <p style={{ color: 'red', fontSize: 12 }}>{errors.bank_branch}</p>
                  )}
                </div>
              </div>

              <div className="mt-5">
                <p style={{ fontWeight: 'bold' }}>Seller Agreement</p>
                <div>
                  <label>
                    <input type="checkbox" onChange={() => handleCheckbox()} />
                    <span style={{ marginLeft: 5 }}>
                      I have read and agree to comply with and/or be bound by the terms and
                      conditions of
                      <span>
                        <a target="_blank" href="https://jivimart.com/additional/termsCondition">
                          AiviMart (B2B) Terms &amp; Conditions
                        </a>
                      </span>
                    </span>
                  </label>
                </div>
              </div>

              <div className="mt-4">
                {checkboxMsg && checkboxMsg ? (
                  <p style={{ color: 'grey', fontSize: 12, marginLeft: 10 }}>
                    * Approve the Seller Agreement to Continue
                  </p>
                ) : (
                  ''
                )}
              </div>

              <div className="mb-6">
                <button
                  disabled={disable}
                  type="button"
                  className="mt-1 text-center legal-page-continue-btn"
                  style={{
                    textDecorationLine: 'none',
                    border: 'none',
                    marginBottom: '30px',
                    color: disable ? '#888' : '#fff'
                  }}
                  onClick={handleSubmit}>
                  {disable ? 'Complete To Continue' : 'Continue'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* <Outlet /> */}
    </div>
  );
};

export default CompanyBusinessDetails;
